import { ExchangeCurrency } from "@prisma/client";
import { roundMoney } from "@/app/libs/listingChargeAmount";

const convertPrice = async (
  price: number,
  fromCurrencyCode: string,
  toCurrencyCode: string,
  rates: ExchangeCurrency | null,
) => {
  if (!price || price <= 0) {
    console.warn("Invalid price: must be a positive number");
    return price;
  }

  if (!rates) {
    console.warn("No currency rates available");
    return price;
  }

  try {
    if (!(fromCurrencyCode in rates) || !(toCurrencyCode in rates)) {
      console.warn(`Currency codes not found. From: ${fromCurrencyCode}, To: ${toCurrencyCode}`);
      return price;
    }

    const fromExchangeRate = rates[fromCurrencyCode as keyof typeof rates];
    const toExchangeRate = rates[toCurrencyCode as keyof typeof rates];

    if (typeof fromExchangeRate !== "number" || typeof toExchangeRate !== "number") {
      return price;
    }

    const usdEquivalent = price / fromExchangeRate;
    // Every converted price is a money value: keep it at 2 decimals so the
    // stored/shown amount never carries full float precision.
    const convertedPrice = roundMoney(usdEquivalent * toExchangeRate);

    return convertedPrice;

  } catch (error) {
    console.error("Error during currency conversion:", error);
    return price;
  }
};

export default convertPrice;
